import React, { useMemo } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import ReactList from 'react-list'

import { teamCalendarAction } from '../../../actions'
import { teamCalendarSelector } from '../../../selectors'

import metrolendarHelper from './helper'
import { Group } from './group'
import { FONTS } from '../../../constants'

import { DatesRow } from './dates-row'
import { DummyRow } from './dummy-row'
import { SummaryRow } from './summary-row'

export const VerticalTableCalendar = (props) => {
  const dispatch = useDispatch()
  const openedItems = useSelector(teamCalendarSelector.getOpenedItems)
  const {
    events,
    summary,
    publicHolidays,
    teamCalendar,
  } = props

  const moment = useSelector(teamCalendarSelector.getMoment)
  const range = useSelector(teamCalendarSelector.getRange)

  const dates = useMemo(() => metrolendarHelper.getTableDates(moment, range), [moment, range])
  const groups = useMemo(() => metrolendarHelper.generateMetrolendarEventsTableLookup(events), [events])

  const onGroupHeaderClick = (group) => {
    const { setOpenTeamCalendar } = teamCalendarAction
    dispatch(setOpenTeamCalendar({ [group.id]: !openedItems[group.id] }))
  }

  const renderItem = (index) => {
    return (
      <Group
        key={ `vertical-table-calendar${index}` }
        group={ Object.entries(groups)[index][1] }
        dates={ dates }
        publicHolidays={ publicHolidays }
        teamCalendar={ teamCalendar }
        onGroupHeaderClick={ onGroupHeaderClick }
      />
    )
  }

  return (
    <TableContainer>
      <DatesRow dates={ dates } />
      <DivCalendar>
        <ReactList
          itemRenderer={ renderItem }
          length={ Object.keys(groups).length }
        />
        <div>
          <DummyRow />
        </div>
      </DivCalendar>
      <div>
        { teamCalendar && summary && <SummaryRow dates={ dates } summary={ summary } /> }
      </div>
    </TableContainer>
  )
}

const DivCalendar = styled.div`
  width: 100%;
  overflow-y: scroll;
  margin-top: 50px;
  max-height: calc(100vh - 175px);
  ::-webkit-scrollbar {
    display: none;
  }
  font-size: ${FONTS.SMALL_SIZE};  
`
const TableContainer = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  position: relative;
  width: 100%;
  height: calc(100vh - 130px);
  margin-top: 10px;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  border: solid #EAEAEA;
  border-width: 1px 0px 0px 1px; /* global top + left */
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/index.js